import React from 'react'

export const Loading = () => {
  return (
    <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-60 z-10">
      <svg
        className="w-6 h-6 text-white animate-spin"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 000 16v-4l-3 3 3 3v-4a8 8 0 01-8-8z"
        />
      </svg>
    </div>
  )
}
